module.exports = __webpack_public_path__ + "assets/images/cubo-magico_37aad00bbd716382777978c037f76177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cubo/cubo-magico.png
// module id = 197
// module chunks = 0